import React from 'react';
import { Time16 } from '@carbon/icons-react';
import useOverscrollNavigation from 'customHooks/useOverscrollNavigation';

const ReferralResponseExpired = ({
  onScrollPastEnd,
  onScrollPastStart,
  showPreviousOverscroll,
  showNextOverscroll
}: {
  onScrollPastEnd?: () => void;
  onScrollPastStart?: () => void;
  showPreviousOverscroll?: boolean;
  showNextOverscroll?: boolean;
}) => {
  const { touchHandlers, OverscrollIndicators } = useOverscrollNavigation({
    onScrollPastEnd,
    onScrollPastStart,
    showPreviousOverscroll,
    showNextOverscroll
  });

  return (
    <div className="mobile-view-response-not-ready" {...touchHandlers}>
      <OverscrollIndicators />

      <div className="mobile-view-not-ready-content">
        <div>
          <Time16 className="mobile-view-time-icon" />
        </div>
        <div className="mobile-view-not-ready-text">
          <div className="mobile-view-not-ready-title">
            This enquiry&apos;s responses are no longer available
          </div>
          <div className="mobile-view-not-ready-description">
            Responses are automatically deleted 90 days after the date they were
            received. You can still see the enquiry details and duplicate the
            enquiry.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralResponseExpired;
